





















import { Component, Prop, Watch } from 'vue-property-decorator';
import { CharacterStatisticsBlockViewObject, CharacterStatisticViewObject } from '@/types/apiServerContract';
import { WoWClassMap } from '@/core/game/WoWClasses';
import { WoWRaceMap } from '@/core/game/WoWRaces';

import StatisticsService from '@/services/statistics/statistics.service';

import DoughnutChart from '@/components/graphs/DoughnutChart.vue';
import BaseBlock from './BaseBlock.vue';

@Component({
    components: { BaseBlock, DoughnutChart }
})
export default class CharacterStatisticsBlock extends BaseBlock {
	@Prop({
	    required: true,
	    type: Object
	})
	content!: CharacterStatisticsBlockViewObject;

	statistics: CharacterStatisticViewObject | null = null;

	get col() {
	    return this.content.horizontal ? '6' : '12';
	}

	get ClassData() {
	    return this.statistics?.classDistributions ?? [];
	}

	get ClassLabels() {
	    return Array.from(WoWClassMap.values()).map(x => x.name);
	}

	get ClassColors() {
	    return Array.from(WoWClassMap.values()).map(x => x.color);
	}

	get RaceData() {
	    return this.statistics?.raceDistributions ?? [];
	}

	get RaceLabels() {
	    return Array.from(WoWRaceMap.values()).map(x => x.name);
	}

	get RaceColors() {
	    return Array.from(WoWRaceMap.values()).map(x => x.color);
	}

	async getStatistics() {
	    if (this.content.realmId <= 0) return;

	    const result = await StatisticsService.GetCharacterStatistics.requestData(this.content.realmId);
	    this.statistics = result;
	}

	created() {
	    this.getStatistics();
	}

	@Watch('content.realmId')
	onRealmIdChange() {
	    this.getStatistics();
	}
}
